import React from 'react';
import s from '../About/About_us.module.css';
import logo from '../../images/header/logo.png';
import background from '../About/AboutImg/AboutWomen.png';
import Container from '../Container/Container';

export default function GameAccessories() {
  return (
    <div className={s.conteinerAccesoriesGame}>
      <Container>
        <div className={s.left_blockGame}>
          <img src={logo} alt="" />
          <h2 className={s.title}>
            Геймерські аксесуари з топовим функціоналом{' '}
          </h2>
          <ul className={s.GameAccessories}>
            <li className={s.list_title}>
              Наша продукція представлена на ринку України вже більше 4 років.
            </li>
            <li className={s.list_title}>
              Бренд GAMEPRO– це команда інженерів, технологів, дизайнерів,&ensp;
              &ensp;&ensp;&ensp;&ensp;&ensp;&ensp; геймерів, завдяки спільним
              старанням яких створюється
              &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
              висококласна ігрова периферія за привабливими цінами.
            </li>
            <li className={s.list_title}>
              {' '}
              Ви професійний геймер чи пересічний користувач ПК?{' '}
            </li>
            <li>
              У нашому асортименті ви знайдете пристрій, який зробить вашу
              роботу легшою, цікавішою та якіснішою.
            </li>
          </ul>
        </div>
      </Container>
      <div className={s.right_block}>
        <img src={background} alt="" className={s.Img_right_blockGame} />
      </div>
    </div>
  );
}
